export const T = {
  en_GB: {
    platform: "Platform",
    selectPlatformPlaceholder: "Select a platform",
    noPlatformAvailable: "No platform is available for this combination",
    platformUnresolvedHint: "Complete the financial situation to determine available platforms",
  },
  nb_NO: {
    platform: "Plattform",
    selectPlatformPlaceholder: "Velg en plattform",
    noPlatformAvailable: "Ingen plattform er tilgjengelig for denne kombinasjonen",
    platformUnresolvedHint:
      "Fyll ut den økonomiske situasjonen for å avgjøre tilgjengelige plattformer",
  },
} as const;
